import { notifyHandledException } from '../bugsnag';

const gtmEvents = require.context('./gtmEvents', true, /\.js$/, 'lazy');

export const gtmPush = (eventType, eventObject) => {
  try {
    gtmEvents(`./${eventType}.js`)
      .then(event => {
        event.default(eventObject);
      })
      .catch(err => {
        notifyHandledException(err);
      });
  } catch (e) {
    notifyHandledException(e);
  }
};
